function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Popover, PopoverBody } from 'reactstrap';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import AssociatedAssetOrganizationFilter from '../../../assets/associatedAssetOrganizationFilter';
import AssociatedAssetTypeFilter from '../../../assets/associatedAssetTypeFilter';
import ControlFilterSwitch from '../../../common/controls/controlFilterSwitch';
import entityComposition from '../../../common/classes/entityComposition';
const AssetSelectionModal = ({
  associatedAsset: {
    indexQuery,
    loading
  },
  associatedAssetActions: {
    filterClear,
    serverFilter
  },
  isOpen: _isOpen = false,
  jobID,
  onSelect,
  onToggle,
  targetElementID
}) => {
  let controlFilterSwitch = null;

  // add the job to the base filters
  const filters = useMemo(() => _objectSpread(_objectSpread({}, indexQuery.filters), {}, {
    job: jobID
  }), [indexQuery.filters, jobID]);
  useEffect(() => {
    if (!_isOpen) {
      // whenever the modal is closed, clear the filter selections
      filterClear();
    }
  }, [filterClear, _isOpen]);
  const filterChange = (key, value) => {
    const newFilters = _objectSpread(_objectSpread({}, filters), {}, {
      [key]: value
    });
    serverFilter(newFilters, indexQuery);
  };
  const handleSelect = ({
    id,
    name
  }) => {
    onSelect({
      id,
      title: name
    });
  };
  const handleBack = () => controlFilterSwitch.controlSwitch.switchControl();
  const AssociatedAssetOrganizationFilterControl = /*#__PURE__*/React.createElement(AssociatedAssetOrganizationFilter, {
    assetsLoading: loading,
    filters: filters,
    onFilter: filterChange,
    onBack: handleBack,
    onAdd: handleSelect
  });
  const AssociatedAssetTypeFilterControl = /*#__PURE__*/React.createElement(AssociatedAssetTypeFilter, {
    assetsLoading: loading,
    filters: filters,
    onFilter: filterChange,
    onBack: handleBack,
    onAdd: handleSelect
  });
  const filterControls = [{
    label: 'Organizations',
    filterName: ['organization', 'facility', 'facilityGroup', 'facilityGroupArea'],
    control: AssociatedAssetOrganizationFilterControl,
    filters
  }, {
    label: 'Category / Type',
    filterName: ['assetCategoryName', 'assetType'],
    control: AssociatedAssetTypeFilterControl,
    filters
  }];
  return /*#__PURE__*/React.createElement(Popover, {
    className: "t-as-modal",
    delay: 0,
    isOpen: _isOpen,
    placement: "bottom",
    target: targetElementID,
    toggle: onToggle,
    trigger: "click legacy"
  }, /*#__PURE__*/React.createElement(PopoverBody, null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '275px',
      padding: '15px'
    }
  }, /*#__PURE__*/React.createElement(ControlFilterSwitch, {
    filterControls: filterControls,
    ref: input => {
      controlFilterSwitch = input;
    }
  }))));
};
AssetSelectionModal.propTypes = {
  associatedAsset: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }),
    initialIndexQuery: PropTypes.shape({}),
    loading: PropTypes.bool
  }).isRequired,
  associatedAssetActions: PropTypes.shape({
    filterClear: PropTypes.func,
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  isOpen: PropTypes.bool,
  jobID: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  targetElementID: PropTypes.string.isRequired
};
export { AssetSelectionModal as UncomposedAssetSelectionModal };
export default entityComposition(AssetSelectionModal, ['associatedAsset'], {
  jobID: state => state.report.active.Job.id
});